"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS = void 0;
const STATUS = exports.STATUS = {
  DEFAULT: 'default',
  VERIFYING: 'verifying',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  ERROR: 'error',
  SUCCESS: 'success'
};